import React, { useRef, useState } from "react";
import { Row, Col, Carousel } from "antd";
import { useParams } from "react-router-dom";

import useMapData from "../../utils/useMapData";
import useWindowDimensions from "../../utils/useWindowDimensions";

import { ModalOverlay } from "../Modal/Modal";
import Header from "../Header/Header";
import PreRegisterSection from "../Forms/PreRegisterSection";
import Price from "../Price/Price";
import SitePlan from "../SitePlan/SitePlan";
import Amenities from "../Amenities/Amenities";
import Location from "../Location/Location";
import VirtualSiteTour from "../VirtualSiteTour/VirtualSiteTour";
import Footer from "../Footer/Footer";
import Banner from "../Banner/Banner";
import RegisterForm from "../Forms/RegisterForm";
import Payment from "../Payment/Payment";
import Gallery from "../Gallery/Gallery";
import { H1, H3, H4, OutlineButton, VerticalText } from "../../StyledCmp";

import Download from "../../assets/download_gif.gif";

import "./HomeSection.scss";

const scrollToRef = ref => {
  let newRef = ref.current.offsetTop - 100;
  window.scrollTo({ top: newRef, behavior: "smooth" });
};

const HomeSection = () => {
  const { width } = useWindowDimensions();

  const isWideScreen = width > 768;

  const DownloadIcon = () => <img width={24} src={Download} alt="" />;

  const [isModaleVisible, setIsModaleVisible] = useState(false);

  const { propertyId } = useParams();
  const resultList = useMapData(propertyId);

  const overviewRef = useRef(null);
  const priceRef = useRef(null);
  const sitePlanRef = useRef(null);
  const ammenitiesRef = useRef(null);
  const galleryRef = useRef(null);
  const paymentRef = useRef(null);
  const locationRef = useRef(null);
  const virtualTourRef = useRef(null);

  const refObject = {
    overviewRef,
    priceRef,
    sitePlanRef,
    ammenitiesRef,
    galleryRef,
    paymentRef,
    locationRef,
    virtualTourRef,
  };

  const executeScroll = view => {
    scrollToRef(refObject[view]);
  };

  const handleModalVisibility = () => {
    setIsModaleVisible(prevState => !prevState);
  };

  return (
    <>
      <Row justify="center" className="row_wrapper">
        <Col lg={18}>
          <Header
            onScroll={executeScroll}
            handleModalVisibility={handleModalVisibility}
          />
          <Carousel autoplay effect="fade">
            {resultList.carouselImages &&
              resultList.carouselImages.map((image, index) => (
                <React.Fragment key={image}>
                  <div>
                    <img className="carousel-img" src={image} alt="carousel" />
                    {isWideScreen ? <Banner /> : null}
                  </div>
                </React.Fragment>
              ))}
          </Carousel>
          <div className="mobile_pre_register">
            <Banner />
            <RegisterForm handleModalVisibility={handleModalVisibility} />
          </div>
          <Row className="info_wrapper" ref={overviewRef}>
            <div
              style={{
                display: "flex",
                justifyContent: isWideScreen ? "space-around" : "center",
                marginRight: "0.5em",
              }}
            >
              <Col lg={22}>
                <H1>{resultList?.projectName}</H1>
                <H4>At {resultList?.locationName}</H4>
                <p>{resultList?.projectDescription}</p>
                <Col lg={6}>
                  <OutlineButton
                    className="animated slideInDown"
                    icon={<DownloadIcon />}
                    onClick={handleModalVisibility}
                    // download={resultList?.downloadBrochureUrl}
                  >
                    Download Brochure
                  </OutlineButton>
                </Col>
                <H3>About {resultList?.projectOwner}</H3>
                <p>{resultList?.projectOwnerDescription}</p>
              </Col>
              <Col lg={1} className="vertical_text">
                <VerticalText>Overview</VerticalText>
              </Col>
            </div>
          </Row>
          <Price ref={priceRef} />
          <SitePlan ref={sitePlanRef} />
          <Amenities ref={ammenitiesRef} />
          <Gallery ref={galleryRef} />
          <Payment ref={paymentRef} />
          <Location ref={locationRef} />
          <VirtualSiteTour ref={virtualTourRef} />
          <Footer />
        </Col>
        <Col lg={6} className="service">
          <PreRegisterSection />
        </Col>
      </Row>

      {isModaleVisible && (
        <ModalOverlay
          isModalVisible={isModaleVisible}
          handleModalVisibility={handleModalVisibility}
          actionType="download-brochure"
        />
      )}
    </>
  );
};

export default HomeSection;
